__webpack_require__.p = "/Simpsons-Memory-Card-Game/";